import { v4 as uuid } from "uuid";
import FileUploadHandler from "../components/Gallery/model/FileUploadHandler.model";
import FileUpload from "../components/Gallery/model/FileUpload.model";
import AttachmentApi from "../api/services/AttachmentApi";
import AttachmentDispatcher from "./AttachmentDispatcher";
import AttachmentFileHandler from "./AttachmentFileHandler";
import LoadedFile from "../components/Gallery/model/LoadedFile.model";
import EnqueuedFile from "../components/Gallery/model/EnqueuedFile";

export default class AttachmentFileUploadHandler implements FileUploadHandler {
  constructor(private attachmentApi: AttachmentApi) {}

  upload(
    serviceId: string,
    files: EnqueuedFile[],
    afterUpload?: (loadedFile: LoadedFile) => Promise<unknown>,
  ): FileUpload[] {
    return files.map((file) => {
      const dispatcher = new AttachmentDispatcher();
      const formData = new FormData();
      formData.append("file", file.file);
      if (file.name) {
        formData.append("filename", file.name);
      }
      formData.append("description", file.description || "");
      if (file.flag?.tags.length) {
        formData.append("tags", file.flag.tags.join(","));
      }
      const upload = () =>
        this.attachmentApi
          .uploadFile(formData, (progressEvent) => dispatcher.progressEvent(progressEvent))
          .then((response) => response.data)
          .then((attachment) => AttachmentFileHandler.toLoadedFile(attachment, "READ_WRITE", file.flag));
      return {
        state: "WAITING",
        id: uuid(),
        name: file.name ? file.name : file.file.name?.normalize(),
        serviceId,
        upload,
        flag: file.flag,
        progress: dispatcher,
        notifications: file.notifications,
        afterUpload,
      };
    });
  }
}
